import React from 'react'
import SortableTable, {ColumnConfig} from '../SortableTable'
import {useSelector} from 'react-redux'
import HighlightText from '../HighlightText'
import PropTypes from 'prop-types'
import RXRButton from '../RXRButton'
import {selectGroupsLookupByActiveOrganization} from '../../reducers/selectors'
import {getResidentGroupsLabel} from '../../Utils/globalAdminUtils'
import RXRIcon from '../RXRIcon'
import EmptyStateIconAndMessage from '../EmptyStateIconAndMessage'

function ListDocumentsAtBuildingTable(props) {
  const building = useSelector(state => state.GlobalAdmin.buildingsLookup[props.buildingId])
  const documentsAtAsset = useSelector(state => state.GlobalAdmin.documentsByBuilding[props.buildingId])
  const documentsLookup = useSelector(state => state.GlobalAdmin.documentsLookup)
  const orgGroupsLookup = useSelector(selectGroupsLookupByActiveOrganization)

  const hasFiltersApplied = !!(props.filterTerm || props.selectedTagFilters)

  const dataToRender = (documentsAtAsset || [])
    .map(d => documentsLookup[d])
    .map(d => {
      return {
        documentId: d.id,
        documentNameInternal: d.internalName || d.displayName, // default to displayName if internalName is not set
        documentNameExternal: d.displayName,
        residentGroups: getResidentGroupsLabel(d.residentGroups, orgGroupsLookup),
      }
    })
    .filter(item => {
      if (!props.filterTerm) {
        return true
      }
      const lowerFilter = props.filterTerm.toLowerCase()
      return (
        item.documentNameInternal.toLowerCase().includes(lowerFilter) ||
        item.documentNameExternal.toLowerCase().includes(lowerFilter) ||
        item.residentGroups.toLowerCase().includes(lowerFilter)
      )
    })

  const columns = [
    new ColumnConfig({
      title: 'Document name (Dashboard)',
      renderPrimitive: item => item.documentNameInternal,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('documentNameInternal'),
    }),

    new ColumnConfig({
      title: 'Document name (App)',
      renderPrimitive: item => item.documentNameExternal,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('documentNameExternal'),
    }),

    new ColumnConfig({
      title: 'Resident group(s)',
      renderPrimitive: item => item.residentGroups,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('residentGroups'),
    }),

    new ColumnConfig({
      title: '',
      render: (r, col) => {
        return (
          <RXRButton onClick={() => props.handleClickDocument(r.documentId)} type={RXRButton.TYPE_SECONDARY}>
            View
          </RXRButton>
        )
      },
    }),
  ]

  if (dataToRender.length > 0) {
    return <SortableTable data={dataToRender} columns={columns} getKey={d => d.documentId} />
  }

  // Show appropriate empty state
  if (hasFiltersApplied && documentsAtAsset.length > 0) {
    return <EmptyStateIconAndMessage message={'No documents match the selected filter(s)'} icon={RXRIcon.APP_DOCUMENTS} />
  }

  return <EmptyStateIconAndMessage message={`No documents at ${building.displayName}`} icon={RXRIcon.APP_DOCUMENTS} />
}

ListDocumentsAtBuildingTable.propTypes = {
  handleClickDocument: PropTypes.func.isRequired,
  buildingId: PropTypes.string.isRequired,
  filterTerm: PropTypes.string,
}

export default ListDocumentsAtBuildingTable
